import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import LocalFeed from './pages/LocalFeed';
import PostView from './pages/PostView';
import Login from './pages/Login';
import './App.css';

function NavigationBar() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    alert('Logged out successfully!');
  };

  return (
    <nav className="topnav">
      <div className="brand">conneCT</div>
      <div className="navlinks">
        <Link to="/">Home</Link>
        <Link to="/local">Discover</Link>
        <Link to="/events">Events</Link>
        <Link to="/groups">Groups</Link>
        {user ? (
          <div className="user-menu">
            <span className="user-name">Hi, {user.displayName || user.nickname || user.firstName}!</span>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        ) : (
          <Link to="/login">Log In</Link>
        )}
      </div>
    </nav>
  );
}

function AppContent() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="App">
      <NavigationBar />

      {/* Main Content */}
      <main className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/local" element={<LocalFeed />} />
          <Route path="/p/:id" element={<PostView />} />
          <Route path="/events" element={
            <div className="card">
              <h2>Events Coming Soon!</h2>
              <p>We're working on bringing you local events and activities.</p>
            </div>
          } />
          <Route path="/groups" element={
            <div className="card">
              <h2>Groups Coming Soon!</h2>
              <p>Connect with like-minded people in your area.</p>
            </div>
          } />
          <Route path="/login" element={<Login />} />
        </Routes>
      </main>

      {/* Scroll to top button */}
      <button
        className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        ↑
      </button>
    </div>
  );
}

function App() {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;